/**
 * Native hard auth gate — the route an unauthenticated user tried to reach
 * (including one opened via a deep link) before being bounced to Login. The gate
 * in `App.tsx` stashes it here; `useLogin` consumes it after a successful
 * sign-in so the user lands where they originally intended instead of Home.
 *
 * Kept as a tiny module singleton (not context) so both the navigation-level
 * gate and the login hook can reach it without threading props through the tree.
 */
export type PendingRoute = { name: string; params?: object };

let pending: PendingRoute | null = null;

export const setPendingRoute = (route: PendingRoute): void => {
  pending = route;
};

/** CORE-1391 — whether a route is waiting, without consuming it (login analytics). */
export const hasPendingRoute = (): boolean => pending !== null;

/** Return the stashed route (if any) and clear it — single-use by design. */
export const takePendingRoute = (): PendingRoute | null => {
  const route = pending;
  pending = null;
  return route;
};
